// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"a1bd168a","453":"9329db76"}[chunkId] + ".chunk.js";
};